import { fetchApi } from "./fetchApi";

export default {
  async create({ categoryId, name }) {
    const response = await fetchApi({
      data: {
        categoryId,
        name,
      },
      method: "post",
      url: "/api/serviceAreaAttribute/",
    });

    return response.data.result;
  },
  get(id) {
    return fetchApi({
      method: "get",
      url: `/api/serviceAreaAttribute/${id}`,
    });
  },
  async list() {
    const response = await fetchApi({
      method: "get",
      url: "/api/serviceAreaAttribute",
    });
    return response;
  },
  async update(serviceAreaAttribute) {
    const url = `/api/serviceAreaAttribute/${serviceAreaAttribute.id}`;
    const data = Object.assign({}, serviceAreaAttribute);
    delete data.id;

    const response = await fetchApi({
      data,
      method: "put",
      url,
    });

    return response.data.result;
  },
};
